










































import { user } from '../fire.coffee'

export default
    props: ['required']
    data: ->
        user: user
    computed:
        countries: -> 
            locale = this.$root.$i18n.locale
            counts = [...this.$countries()]
            index = counts.findIndex (e) -> e[locale]?
            if index > -1
                element = counts[index]
                counts.splice(index, 1)
                counts.unshift(element)
            return counts
